import React, { useCallback, useContext, useState } from 'react';
import LeadNotificationsContext from './LeadNotifications.context';
import useLeadNotificationsQuery from './hooks/useLeadNotificationsQuery';
import AuthContext from 'providers/Auth/Auth.context';
import useNotificationsCommon from 'hooks/useNotificationCommon';
import { SearchableFilterValue } from 'models/Filters';

const LeadNotifications: React.FC = (props) => {
  const { children } = props;

  const [channel, setChannel] = useState<string[]>([]);
  const [status, setStatus] = useState<string[]>([]);
  const [leads, setLeads] = useState<SearchableFilterValue>([]);
  const [deals, setDeals] = useState<SearchableFilterValue>([]);

  const { isLoggedIn } = useContext(AuthContext);

  const resetFilters = useCallback(() => {
    setChannel([]);
    setStatus([]);
    setLeads([]);
    setDeals([]);
  }, []);

  const {
    query: {
      data: notificationsData,
      isFetching,
      hasNextPage,
      isFetchingNextPage,
      fetchNextPage,
    },
  } = useLeadNotificationsQuery({
    channel,
    status,
    leads,
    deals,
    enabled: isLoggedIn,
  });

  const { notifications, numberOfPlaceholders, onNotificationsScroll } =
    useNotificationsCommon(
      notificationsData,
      isFetching,
      isFetchingNextPage,
      hasNextPage,
      fetchNextPage,
    );

  return (
    <LeadNotificationsContext.Provider
      value={{
        fetchingNotifications: isFetching,
        numberOfPlaceholders,
        notifications,
        channel,
        status,
        leads,
        deals,
        setChannel,
        setStatus,
        setLeads,
        setDeals,
        resetFilters,
        onNotificationsScroll,
      }}
    >
      {children}
    </LeadNotificationsContext.Provider>
  );
};

export default LeadNotifications;
